import { useCallback, useEffect, useRef, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

const MINUTO = 60 * 1000;
const INATTIVITA = 30 * MINUTO;     // logout automatico dopo 30 minuti senza attività
const AVVISO = 29 * MINUTO;         // avviso un minuto prima
const RINNOVO = 10 * MINUTO;        // rinnovo della sessione durante l'uso

/** Disconnette dopo 30 minuti di inattività, con avviso e possibilità di restare connessi. */
export const SessionTimer = () => {
  const { user, logout } = useAuth();
  const [avviso, setAvviso] = useState(false);
  const [secondi, setSecondi] = useState(60);
  const attivita = useRef(Date.now());
  const rinnovo = useRef(Date.now());

  const resetta = useCallback(() => {
    attivita.current = Date.now();
    setAvviso(false);
    if (Date.now() - rinnovo.current > RINNOVO) {
      rinnovo.current = Date.now();
      api.post("/auth/refresh").catch(() => {});
    }
  }, []);

  useEffect(() => {
    if (!user) return undefined;
    const eventi = ["mousedown", "keydown", "wheel", "touchstart", "scroll"];
    eventi.forEach((e) => window.addEventListener(e, resetta, { passive: true }));
    const tick = setInterval(() => {
      const fermo = Date.now() - attivita.current;
      if (fermo >= INATTIVITA) {
        sessionStorage.setItem("bc-sessione-scaduta", "1");
        logout();
      } else if (fermo >= AVVISO) {
        setAvviso(true);
        setSecondi(Math.max(1, Math.ceil((INATTIVITA - fermo) / 1000)));
      }
    }, 1000);
    return () => {
      eventi.forEach((e) => window.removeEventListener(e, resetta));
      clearInterval(tick);
    };
  }, [user, logout, resetta]);

  if (!user || !avviso) return null;
  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/50 p-4"
      data-testid="session-warning">
      <div className="w-full max-w-sm rounded-sm border border-border bg-card p-4 space-y-3">
        <h2 className="font-head text-lg font-bold">Sessione in scadenza</h2>
        <p className="text-sm text-muted-foreground">
          Per sicurezza stai per essere disconnesso per inattività.
          Chiusura automatica tra <span className="font-bold tabular-nums">{secondi}</span> secondi.
        </p>
        <div className="flex gap-2">
          <button type="button" data-testid="session-stay"
            className="h-10 flex-1 rounded-sm bg-primary text-primary-foreground text-sm font-semibold"
            onClick={resetta}>Resta connesso</button>
          <button type="button" data-testid="session-logout"
            className="h-10 px-4 rounded-sm border border-border text-sm font-semibold"
            onClick={() => logout()}>Esci ora</button>
        </div>
      </div>
    </div>
  );
};

export default SessionTimer;
